import component from './projectsCollection.vue'

export default component
